module.exports = __webpack_public_path__ + "fonts/DM_Sans-400-latin9.3ccd9ab.woff2";